import React, { useContext, useState, useEffect } from 'react';
import { Table, TableBody } from '@material-ui/core';
import { set, format, addMinutes, isValid, parseISO } from 'date-fns';
import _ from 'lodash';

import './AddMeetingForm.scss';
import RaceRow from './RaceRow/RaceRow';
import RaceHeader from './RaceHeader/RaceHeader';
import RaceRowRunner from './RaceRowRunner/RaceRowRunner';
import RaceTableHeader from './RaceTableHeader/RaceTableHeader';
import AddMeetingContext from 'src/pages/AddMeeting/Context/AddMeeting.context';

export default function AddMeetingFormStep2() {
  const { stepErrors, setStepErrors, formData } = useContext(AddMeetingContext);
  const [ races, setRaces ] = useState({});

  useEffect(() => {
    const allRaces = _.map(_.range(formData.numberRaces), index => {
      const scheduledTime = set(new Date(), {
        hours: formData.startTime.split(':')[0], minutes: formData.startTime.split(':')[1]
      });

      return {
        id: index,
        scheduledTime: format(addMinutes(scheduledTime, index * formData.intervalTime), 'HH:mm'),
        runnerCount: 0,
        runners: [],
        markets: [],
        autoClose: true,
        rule4: true,
        places: 3,
        status: 'open',
        isOpen: true
      };
    });

    setRaces(allRaces);
  }, [formData]);

  useEffect(() => {
    if (formData?.races) {
      setRaces(JSON.parse(formData.races));
    }
  }, []);

  const onChange = (key, race, value, isDate = false) => {
    const date = isValid(parseISO(value)) && isDate ? format(value, 'HH:mm') : null;

    setRaces({
      ...races,
      [race.id]: {
        ...races[race.id],
        [key]: isDate ? date : value
      }
    });

    if (key === 'runnerCount' && value >= 0) {
      const runners = _.map(_.range(value), (v, i) => ({ id: i + 1, name: '', nonRunner: false }));

      setRaces({
        ...races,
        [race.id]: {
          ...races[race.id],
          [key]: value,
          runners: runners
        }
      });
    }
  };

  const onChangeRunner = (key, index: number, race, value) => {
    const runners = [ ...races[race.id].runners ];
    runners[index][key] = value;

    setRaces({
      ...races,
      [race.id]: {
        ...races[race.id],
        runners
      }
    });
  };

  const onError = (element: string, message: string) => {
    if (_.isEmpty(message)) {
      const _stepErrors = [...stepErrors];
      const errorIndex = _.findIndex(_stepErrors, { step: 1, element });
      if (errorIndex !== -1) {
        _.pullAt(_stepErrors, errorIndex);

        setStepErrors(_stepErrors);
      }
    } else {
      const error = _.find(stepErrors, { step: 1, element });
      if (error) {
        error.message = message;
      } else {
        stepErrors.push({ step: 1, element, message });
      }

      setStepErrors(stepErrors);
    }
  };

  return (
    <div className="add-meeting-form__step">
      <RaceHeader />
      <Table className="add-meeting-form__table">
        <RaceTableHeader />
        <TableBody>
          {
            races && _.map(races, (race: any, irc) =>
              (
                <RaceRow
                  key={ irc + race.id }
                  race={ race }
                  onError={ onError }
                  onChange={ onChange }
                >
                  {
                    (race.runners.length > 0 && race.isOpen) && _.map(race.runners, (runner, irn) => (
                      <RaceRowRunner
                        key={ irn + race.id }
                        race={ race }
                        runner={ runner }
                        i={ irn }
                        onChange={ onChangeRunner }
                      />)
                    )
                  }
                </RaceRow>
              )
            )
          }
        </TableBody>
      </Table>
      <input type="hidden" name="races" value={ JSON.stringify(races) } />
    </div>
  );
}
